import React, { useContext } from 'react';

import Parceiros from '../components/Parceiros'
import {firebaseTimestampToMoment} from '../utils/utils'
import AppContext from '../hooks/AppContext'
import classNames from 'classnames';

import ProgressoSecoes from './ProgressoSecoes'
import ResumoVotacaoItem from './ResumoVotacaoItem'

const wrapperItem = classNames("half-line")

const ResumoVotacao = (props) => {   
    
    const {totalizacao, eleicaoSelecionada, localidadeSelecionada, cargoSelecionado, zonaESelecionada, localVSelecionado} = useContext(AppContext);

    return (        
        <div className="flex flex-wrap flex-grow-1 gap-vhw justify-content-between w-full">

            {totalizacao && props?.renderVotos &&
                <div className={wrapperItem}> 
                    <ResumoVotacaoItem titulo='Nominais' valor={totalizacao?.votosNominais.toLocaleString()}/>  
                </div>
            }   
            {totalizacao && props?.renderVotosBrancos &&
                <div className={wrapperItem}> 
                    <ResumoVotacaoItem titulo='Brancos' valor={totalizacao?.votosBrancos.toLocaleString()}/>  
                </div>  
            }   
            {totalizacao && props?.renderVotosNulos &&   
                <div className={wrapperItem}> 
                    <ResumoVotacaoItem titulo='Nulos' valor={totalizacao?.votosNulos.toLocaleString()}/>  
                </div>    
            }   
            {totalizacao && props?.renderVotos &&
                <div className={wrapperItem}> 
                    <ResumoVotacaoItem titulo='Apurados' valor={totalizacao?.votosApurados.toLocaleString()}/>  
                </div>
            }   
            {totalizacao && props?.renderVotosLegenda && totalizacao?.votosLegenda!=undefined && 
                <div className={wrapperItem}> 
                    <ResumoVotacaoItem titulo='Legenda' valor={totalizacao?.votosLegenda.toLocaleString()}/>  
                </div>
            }   
            {totalizacao && props?.renderVotosAbstencoes &&            
                <div className={wrapperItem}> 
                    <ResumoVotacaoItem titulo='Abstenções' valor={totalizacao?.abstencoes.toLocaleString()}/>  
                </div>
            }
            {(totalizacao ||  props?.acompanhamentoSecoes) && !props?.renderPendencias && 
                <div className="w-full progreso-secoes">                     
                    <ProgressoSecoes titulo={                                
                                totalizacao? "Seções totalizadas" 
                                :(
                                    (eleicaoSelecionada && localidadeSelecionada && cargoSelecionado) && "Aguardando a leitura"
                                ) || "Seções totalizadas"
                            }
                            lidas={props?.acompanhamentoSecoes?.secoesLidas || totalizacao?.secoesLidas} 
                            total={props?.acompanhamentoSecoes?.totalSecoes || (totalizacao?.secoesLidas+ totalizacao?.secoesNaoLidas)}
                            data={firebaseTimestampToMoment(props?.acompanhamentoSecoes?.dataHora || totalizacao?.dataHora)}/>      
                </div>
            }   
            {props?.renderPendencias &&            
                <div className={wrapperItem}> 
                    <ResumoVotacaoItem titulo='Pendências' valor={props?.pendencias?.toLocaleString()}/>  
                </div>
            }
            {props?.renderPendencias &&
                <div className={wrapperItem}>
                    <ResumoVotacaoItem titulo='Resolvidas' valor={props?.pendenciasResolvidas?.toLocaleString()}/>
                </div>
            }            

            <div className="w-full"> 
              <Parceiros/>
            </div>    

        </div>
                   
    );
}

export default ResumoVotacao;